module.exports = __webpack_public_path__ + "assets/img/list-3.93a9153f.png";